import { Injectable } from '@angular/core';
import { CUSTOM_COMPONENTS } from '../constants/customcomponents';
/**
 *
 */
@Injectable()
export class EmbeddedComponents {
	get components(): any {
		return CUSTOM_COMPONENTS;
	}
}
